module.exports = __webpack_public_path__ + "img/JO.0c3a02ce.svg";